module.exports = __webpack_public_path__ + "img/84d9df341b23440bbb47bdaf3885674d-640.a84011bc.jpg";